import knowledgeService from 'services/KnowledgeService';

export function simplifyDocumentItem(item) {
  return {
    ...item,
    associationsFrom: item.associationsFrom ? item.associationsFrom.edges.map((edge) => edge.node) : [],
    associationsTo: item.associationsTo ? item.associationsTo.edges.map((edge) => edge.node) : [],
  };
}

export default function simplifyDocumentQueryResult(data) {
  const docs = data.workspace && data.workspace.competencyDocuments;

  if (!docs) {
    return undefined;
  }

  const firstNode = (docs.edges && docs.edges[0]) ? docs.edges[0].node : undefined;

  if (!firstNode) {
    return undefined;
  }

  const items = (firstNode.items && firstNode.items.edges) ? firstNode.items.edges.map((edge) => edge.node) : [];

  return {
    ...firstNode,
    items: items.map(simplifyDocumentItem),
  };
}

/**
 * get sorted knowledge map list
 * @param {object} data
 */
export const simplifyKnowledgeMapQueryResult = (data) => {
  const docs = data?.workspace?.competencyDocuments || data?.documents;

  if (!docs) {
    return undefined;
  }

  const knowledgeMapList = docs && docs.edges.map((edge) => edge.node).sort(sortDocs);

  return knowledgeMapList;
};

/**
 * sort knowledge map based on title
 * @param {object} docA
 * @param {object} docB
 */
export const sortDocs = (docA, docB) => {
  const titleCompare = docA.title.localeCompare(docB.title);
  return (titleCompare === 0) ? docA.id.localeCompare(docB.id) : titleCompare;
};

/**
 * Add isDeleteOptionAllowed property to KnowledgeMap objects
 * @param {Array.<Object>} data
 * @param {String} userEmail
 */
export const addDeleteProperty = async (data, userEmail) => {
  const transformedKmDocs = data.map(async (kmItem) => {
    const { id } = kmItem;
    const { collaborators: { accounts } } = await knowledgeService.getCollaboratorsList(id);
    const isDeleteOptionAllowed = accounts.some(({ account, permissionLevel }) => permissionLevel === 'OWNER' && account.primaryEmail === userEmail);
    return {
      ...kmItem,
      isDeleteOptionAllowed,
    };
  });

  return await Promise.all(transformedKmDocs);
};
